import { render, staticRenderFns } from "./LabelField.vue?vue&type=template&id=24e3317b&scoped=true&functional=true"
import script from "./LabelField.vue?vue&type=script&lang=js"
export * from "./LabelField.vue?vue&type=script&lang=js"
import style0 from "./LabelField.vue?vue&type=style&index=0&id=24e3317b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "24e3317b",
  null
  
)

export default component.exports